











import { Component, Prop, Vue } from "vue-property-decorator";
import { Icons, ICON_DATA } from "@/app/Icons";

@Component
export default class Icon extends Vue {
  @Prop() type!: Icons;

  get icon() {
    return ICON_DATA[this.type];
  }
}
